import { useCallback } from 'react';
import { useAuthenticatedFetch as useNsiAuthenticatedFetch } from '@nsi-advisory-services/auth-react';
import { IMPERSONATE_HEADER, getImpersonatedEmployeeId } from '../utils/impersonation';

const useAuthenticatedFetch = () => {
  const authFetch = useNsiAuthenticatedFetch();

  return useCallback((url, options = {}) => {
    const headers = new Headers(options.headers);
    if (!(options.body instanceof FormData) && !headers.has('Content-Type')) {
      headers.set('Content-Type', 'application/json');
    }

    // Read per request rather than captured, so it always matches the tab.
    const impersonatedEmployeeId = getImpersonatedEmployeeId();
    if (impersonatedEmployeeId) {
      headers.set(IMPERSONATE_HEADER, impersonatedEmployeeId);
    }

    return authFetch(url, { ...options, headers });
  }, [authFetch]);
};

export default useAuthenticatedFetch;
